import { App, Button, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useState } from 'react';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import Heading from '../../components/common/Heading/Heading';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { deleteLabTests, getLabTests } from '../../network/labTest';
import { colorPrimary, getTimeFormat } from '../../utils/utils';

const LabTests = ({ t }) => {
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const { message } = App.useApp();
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteLabTests(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        // message.success('تم الحذف بنجاح');
        client.invalidateQueries({ queryKey: [queryKeys.getLabTestsList] });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getLabTestsList],
    queryFn: () => getLabTests(),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.patient,
      dataIndex: 'patient',
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/lab-test/${record.name}`)
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.labTestName,
      dataIndex: 'lab_test_name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.lab_test_name).toLowerCase();
        const searchValue = value.toLowerCase();
        return name.includes(searchValue);
      },
    },
    {
      title: t.date,
      dataIndex: 'date',
    },
    {
      title: t.time,
      dataIndex: 'time',
      render: (time) => {
        return <Tag color={colorPrimary}>{getTimeFormat(time)}</Tag>;
      },
    },
    {
      title: t.practitionerName,
      dataIndex: 'practitioner_name',
    },
    {
      title: t.requestingDepartment,
      dataIndex: 'requesting_department',
    },
    {
      title: t.status,
      dataIndex: 'status',
      render: (order) => {
        let color = '';
        let background = '';
        switch (order) {
          case 'Draft':
            background = '#e6f4ff';
            color = '#0958d9';
            break;
          case 'Completed':
            background = '#40C1AC1A';
            color = '#167767';
            break;
          case 'Checked Out':
            background = '#f9f0ff';
            color = '#531dab';
            break;
          case 'Closed':
          case 'Cancelled':
            background = '#EB59591A';
            color = '#EB5959';
            break;
          default:
            break;
        }

        return (
          <Tag
            style={{
              color: color,
              background: background,
              padding: '7px 12px 8px 12px',
              border: 'none',
            }}
          >
            {order || 'Draft'}
          </Tag>
        );
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => navigate(`/lab-test/${record.name}`)}
            >
              <Button
                size="small"
                type="primary"
                // onClick={() => navigate(`/patients/${record.uid}`)}
              >
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletetheLabTest}
              description={t.Areyousuretodeletethislabtest}
              onConfirm={() => handleRemove.mutate(record?.name)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const dataTable = data?.message?.labtests?.map((item, index) => {
    // console.log('item:', item);
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="lab-tests">
      <Heading title={t.Healthcare} subTitle={t.LabTests} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        titleBtn={t.addLabTest}
        Placeholder={t.SearchLabTests}
        pathBtn="/lab-test/add"
      />
    </div>
  );
};

export default LabTests;
